import type { OnOffBlockConfig } from '@lighthouse/core'
import { CheckboxShapeEnum, SwitchTypeEnum } from '@lighthouse/core'

/**
 * 生成按钮block的配置
 *
 * @returns {OnOffBlockConfig}
 */
export const generateOnOffBlock = (mainBreakPoint: string): OnOffBlockConfig => {
    return {
        checkedIcon: {
            icon: {
                type: 'icon',
                value: 'AltArrowUpLinear'
            },
            color: { type: 'color', color: '#98A2B3' }
        },
        unCheckedIcon: {
            icon: {
                type: 'icon',
                value: 'AltArrowDownLinear'
            },
            color: { type: 'color', color: '#98A2B3' }
        },
        defaultChecked: false,
        shape: CheckboxShapeEnum.checkbox,
        showType: SwitchTypeEnum.SWITCH,
        eventList: [],

        breakPoint: {
            id: mainBreakPoint,
            visibility: {
                visible: 'VISIBLE'
            },
            position: {
                type: 'relative'
            },
            size: {
                width: {
                    size: 44,
                    unit: 'px'
                },
                height: {
                    size: 'auto'
                }
            }
        },
        breakPoints: []
    }
}
